import { Radio } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';

export const ModalContent = styled.div`
  padding: 24px;
  color: ${darkgrey};
  text-align: center;
  font-family: Lato;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
`;

export const StyledRadio = styled((props) => <Radio {...props} />)`
  &&& {
    &.MuiFormControlLabel-root {
      justify-content: flex-start;
      gap: 6px;
    }
  }
` as typeof Radio;

export const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Description = styled.div`
  margin-bottom: 24px;
  color: ${darkgrey};
  font-family: Lato;
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
  text-align: start;
`;
